import { useEffect } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import ListKepPage from '@/components/pages/guest/_list-kep/containers/list-kep-page'
import { useFilters } from '@/components/pages/guest/_list-kep/state/filters-atom'
import { searchParamsSchema } from '@/components/pages/guest/_list-kep/types'

export const Route = createFileRoute('/_guest/guest/list-kep')({
  component: RouteComponent,
  validateSearch: searchParamsSchema
})

function RouteComponent() {
  const search = Route.useSearch()
  const filters = useFilters()

  useEffect(() => {
    filters.onStatusChange(search.status, false)
    if (search.province_code) {
      filters.onProvinceChange(search.province_code, false)
    }
    if (search.city_code) {
      filters.onCityChange(search.city_code, false)
    }
    if (search.district_code) {
      filters.onDistrictChange(search.district_code, false)
    }
    if (search.village_code) {
      filters.onVillageChange(search.village_code, false)
    }
    if (search.search) {
      filters.onSearchChange(search.search, false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    search.status,
    search.province_code,
    search.city_code,
    search.district_code,
    search.village_code,
    search.search
  ])

  return <ListKepPage />
}
